"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = NewSingleLineTabs;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function TabPanel(_ref) {
  var children = _ref.children,
    value = _ref.value,
    index = _ref.index;
  return /*#__PURE__*/_react["default"].createElement("div", {
    role: "tabpanel",
    hidden: value !== index,
    id: "simple-tabpanel-".concat(index),
    "aria-labelledby": "simple-tab-".concat(index)
  }, value === index && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      py: 3,
      px: 0
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, null, children)));
}
TabPanel.propTypes = {
  children: _propTypes["default"].element,
  value: _propTypes["default"].number.isRequired,
  index: _propTypes["default"].number.isRequired
};
TabPanel.defaultProps = {
  children: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)
};
function tabProps(index) {
  return {
    id: "simple-tab-".concat(index),
    'aria-controls': "simple-tabpanel-".concat(index)
  };
}

/**
 * @param {*} tabContent<caption>List of objects including tab header description and its DOM content
 * @param {*} sx<caption>@type {@link SxProps<Theme>} Allows defining system overrides as well as additional CSS styles.
 * @returns<caption>@type {NewSingleLineTabs}
 */
function NewSingleLineTabs(_ref2) {
  var tabContent = _ref2.tabContent,
    sx = _ref2.sx,
    selectedTab = _ref2.selectedTab,
    fontSizeTabTitle = _ref2.fontSizeTabTitle;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentTab = _useState2[0],
    setCurrentTab = _useState2[1];
  var TabList = [];
  var TabPanelList = [];
  (0, _react.useEffect)(function () {
    setCurrentTab(selectedTab.index);
  }, [selectedTab]);
  tabContent.forEach(function (item, index) {
    TabList.push( /*#__PURE__*/_react["default"].createElement(_material.Tab, _extends({
      key: "tab_".concat(item.title),
      sx: {
        fontSize: fontSizeTabTitle,
        textTransform: 'none',
        fontWeight: 'bold'
      },
      label: item.title
    }, tabProps(index))));
    TabPanelList.push( /*#__PURE__*/_react["default"].createElement(TabPanel, {
      key: "tab_panel_".concat(item.title),
      index: index,
      value: currentTab
    }, item.content));
  });
  var handleChange = function handleChange(_, newValue) {
    setCurrentTab(newValue);
  };
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: sx
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      borderBottom: 1,
      borderColor: '#D6D6D6',
      maxWidth: 'fit-content'
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Tabs, {
    value: currentTab,
    onChange: handleChange
  }, TabList)), TabPanelList);
}
NewSingleLineTabs.propTypes = {
  tabContent: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  sx: _propTypes["default"].shape({}),
  selectedTab: _propTypes["default"].shape(),
  fontSizeTabTitle: _propTypes["default"].string
};
NewSingleLineTabs.defaultProps = {
  sx: {},
  selectedTab: {
    index: 0,
    time: new Date().getTime()
  },
  fontSizeTabTitle: '14px'
};